import { Component, Input, OnInit } from '@angular/core';
import { DeviceDetectorService } from '@client/app/modules/extension/services/device-detector.service';
import { TranslateService } from '@client/app/services/translate/translate.service';

@Component({
    selector: 'mon-copy',
    templateUrl: './mon-copy.component.html',
    standalone: false,
})
export class MonCopyComponent implements OnInit {
    @Input() target!: string;

    isReady = false;
    tooltip = '';

    constructor (
        private deviceDetectorService: DeviceDetectorService,
        private translateService: TranslateService,
    ) {}

    ngOnInit (): void {
        this.isReady = true;
        this.tooltip = this.translateService.getString('Copied!');
    }

    onError (e: Event): void {
        if (this.deviceDetectorService.isMobile()) {
            this.tooltip = this.translateService.getString('No support');
        } else if (this.deviceDetectorService.os === 'mac') {
            this.tooltip = this.translateService.getString('Press ⌘-C');
        } else {
            this.tooltip = this.translateService.getString('Press Ctrl-C');
        }
    }

    copy (): void {
        if (!this.target) {
            return;
        }

        try {
            const element = document.querySelector('#' + this.target) as HTMLElement;
            if (element) {
                const text = element.innerText || '';

                // Use the Clipboard API if available
                if (navigator.clipboard && navigator.clipboard.writeText) {
                    navigator.clipboard.writeText(text)
                        .catch((error) => {
                            this.onError(new Event('error'));
                        });
                } else {
                    // Fallback for browsers without Clipboard API
                    const textarea = document.createElement('textarea');
                    textarea.value = text;
                    textarea.style.position = 'fixed'; // Prevent scrolling to bottom
                    document.body.appendChild(textarea);
                    textarea.focus();
                    textarea.select();

                    try {
                        const successful = document.execCommand('copy');
                        if (!successful) {
                            this.onError(new Event('error'));
                        }
                    } catch (err) {
                        this.onError(new Event('error'));
                    }

                    document.body.removeChild(textarea);
                }
            }
        } catch (error) {
            this.onError(new Event('error'));
        }
    }
}
